$(function() {
  // 数量増減ボタン
  $('.quantity_icon.plus').on('click',function() {
    max = Number($('#quantity').attr('max'));
    val = Number($('#quantity').val());
    if (val == max) {
      return false;
    }
    val += 1;
    $('#quantity').val(val)
  })

  $('.quantity_icon.minus').on('click',function() {
    min = Number($('#quantity').attr('min'));
    val = Number($('#quantity').val());
    if (val == min) {
      return false;
    }
    val -= 1;
    $('#quantity').val(val)
  })

  // サイズチャートのアコーディオン
  $('.btn_chart').on('click',function() {
    $(this).next().slideToggle();
  })
})